<script setup lang="ts">
definePageMeta({
  heroBackground: 'opacity-80 -z-10'
})
const { fetchList, filteredJobs } = useEnterpriseJobs()

const { data: page } = await useAsyncData('jobs-landing', () => useContent('site').get('/enterprise/jobs'))
if (!page.value) {
  throw createError({ statusCode: 404, statusMessage: 'Page not found', fatal: true })
}

const pageData = computed(() => page.value!.data)

const title = pageData.value.head?.title || pageData.value.title
const description = pageData.value.head?.description || pageData.value.description
useSeoMeta({
  titleTemplate: '%s',
  title,
  description,
  ogDescription: description,
  ogTitle: title
})
useCanonical()

defineOgImage('Docs.takumi', {
  headline: 'Enterprise',
  title,
  description
})

await fetchList()
</script>

<template>
  <UPage v-if="pageData">
    <UPageHero
      :title="pageData.title"
      :description="pageData.description"
      :links="pageData.links"
      :ui="{
        title: 'text-left',
        description: 'text-left',
        links: 'justify-start'
      }"
    />

    <UPageBody>
      <UContainer>
        <div class="space-y-8">
          <UPageCard
            v-for="(job, index) in filteredJobs"
            :key="index"
            :to="job.link"
            :title="job.title"
            :description="job.description"
          >
            <template #leading>
              <UAvatar :src="job.organization.avatar" size="lg" />
            </template>

            <template #footer>
              <div class="flex flex-wrap gap-3">
                <UBadge
                  v-for="location of job.locations"
                  :key="location"
                  :label="location"
                  size="lg"
                  variant="subtle"
                />
                <UBadge :label="job.remote" size="lg" variant="subtle" />
              </div>
            </template>
          </UPageCard>
        </div>
      </UContainer>
    </UPageBody>
  </UPage>
</template>
